/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Full_SizeInputs */

const en_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Full Size`)
};

const es_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver tamaño completo`)
};

const fr_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir en taille réelle`)
};

const de_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In voller Größe ansehen`)
};

const ja_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルサイズで表示`)
};

const zh_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看大图`)
};

const ar_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض بالحجم الكامل`)
};

const id_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Ukuran Penuh`)
};

const it_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza a Schermo Intero`)
};

const ru_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотреть в полном размере`)
};

const pt_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver em Tamanho Original`)
};

const ko_view_full_size = /** @type {(inputs: View_Full_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 크기로 보기`)
};

/**
* | output |
* | --- |
* | "View Full Size" |
*
* @param {View_Full_SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_full_size = /** @type {((inputs?: View_Full_SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Full_SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_full_size(inputs)
	if (locale === "es") return es_view_full_size(inputs)
	if (locale === "fr") return fr_view_full_size(inputs)
	if (locale === "de") return de_view_full_size(inputs)
	if (locale === "ja") return ja_view_full_size(inputs)
	if (locale === "zh") return zh_view_full_size(inputs)
	if (locale === "ar") return ar_view_full_size(inputs)
	if (locale === "id") return id_view_full_size(inputs)
	if (locale === "it") return it_view_full_size(inputs)
	if (locale === "ru") return ru_view_full_size(inputs)
	if (locale === "pt") return pt_view_full_size(inputs)
	return ko_view_full_size(inputs)
});